<template>
  <request-response-placeholder
    showPlaceholder
    message="Pagina não encontrada. Page not found." />
</template>

<script>
import RequestResponsePlaceholder from '@/components/RequestResponsePlaceholder'

export default {
  name: 'PageNotFound',

  components: {
    RequestResponsePlaceholder
  }
}
</script>
